import { AssetResponse } from '@rendernet/api-client';

export const AssetDataIdentifier = {
	ID: 'id',
	URL: 'url',
	STATUS: 'status',
	TAGS: 'tags',
	TYPE: 'type',
	WIDTH: 'width',
	HEIGHT: 'height',
	META: 'metadata',
	EXT: 'ext',
	THUMBNAIL: 'thumbnail',
	IS_NSFW: 'isNsfw',
	NAME: 'name',
};

class ListAssetResponse {
	assets: AssetResponse[];

	constructor(assets: AssetResponse[]) {
		this.assets = assets;
	}

	formatAssetData() {
		if (Array.isArray(this.assets)) {
			return this.assets.map((assetData) => {
				const { metadata = {} } = assetData;
				const { id, type, status, tags, is_nsfw: isNsfw, url, thumbnail, name } = assetData;

				const asset = {};
				asset[AssetDataIdentifier.ID] = id;
				asset[AssetDataIdentifier.URL] = url;
				asset[AssetDataIdentifier.STATUS] = status;
				asset[AssetDataIdentifier.IS_NSFW] = isNsfw;
				asset[AssetDataIdentifier.TAGS] = tags;
				asset[AssetDataIdentifier.TYPE] = type;
				asset[AssetDataIdentifier.META] = metadata;
				asset[AssetDataIdentifier.WIDTH] = metadata.dim?.width;
				asset[AssetDataIdentifier.HEIGHT] = metadata.dim?.height;
				asset[AssetDataIdentifier.EXT] = metadata.ext;
				asset[AssetDataIdentifier.THUMBNAIL] = thumbnail;
				asset[AssetDataIdentifier.NAME] = name;

				return asset;
			});
		}
		return [];
	}
}

export default ListAssetResponse;
